/* eslint-disable no-case-declarations */
type Value = number | string | undefined

export const formatCurrency = (value: Value) => {
  switch (typeof value) {
    case 'string':
      const stringValue = Number(value.replace(/\D/g, '')).toFixed(2)
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(Number(stringValue))
    case 'number':
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    default:
      return value
  }
}
